import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
  Col,
  Row,
} from "reactstrap";
import {
  createMenu,
  createMenuMult,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { ptBR } from "date-fns/locale";

import "react-datepicker/dist/react-datepicker.css";

const CadastrarEvento = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen, calendars } = props;
  const [eventData, setEventData] = useState({
    title: "",
    description: "",
    location: "",
    startDateTime: "",
    endDateTime: "",
    guests: "",
    timezone: "America/Sao_Paulo",
    calendar: "sistemas@absoluteinvest.com.br",
    notifications: [],
  });

  useEffect(() => {
    registerLocale("pt-BR", ptBR);
    setDefaultLocale("pt-BR");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveEvent = () => {
    eventData.guests = eventData.guests?.replace(/\s/g, "").split(",");
    props.createEvent(eventData);
    setOpen();
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setEventData((prevData) => ({
      ...prevData,
      [name]: fieldValue,
    }));
  };

  const handleAddNotification = () => {
    setEventData((prevData) => ({
      ...prevData,
      notifications: [...prevData.notifications, { time: "" }],
    }));
  };

  const handleNotificationChange = (index, field, value) => {
    setEventData((prevData) => {
      const notifications = [...prevData.notifications];
      notifications[index] = {
        ...notifications[index],
        [field]: value,
      };
      return {
        ...prevData,
        notifications,
      };
    });
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader
        style={{ padding: "0.3rem 1rem" }}
        toggle={() => setOpen(!open)}
      >
        Cadastrar Evento{" "}
      </ModalHeader>
      <ModalBody style={{ padding: "0.3rem 1rem" }}>
        <Form>
          <FormGroup>
            <Label style={{ marginBottom: 0 }} for="title">
              Título
            </Label>
            <Input
              style={{ padding: "5px 10px 5px 10px" }}
              type="text"
              name="title"
              id="title"
              value={eventData.title}
              onChange={handleChange}
              placeholder="Insira o Título"
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ marginBottom: 0 }} for="guests">
              Email dos Convidados
            </Label>
            <Input
              style={{ padding: "5px 10px 5px 10px" }}
              type="text"
              name="guests"
              id="guests"
              value={eventData.guests}
              onChange={handleChange}
              placeholder="Insira os emails separados por vírgula"
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ marginBottom: 0 }} for="description">
              Descrição
            </Label>
            <Input
              style={{ padding: "5px 10px 5px 10px", maxHeight: 50 }}
              type="textarea"
              name="description"
              id="description"
              value={eventData.description}
              onChange={handleChange}
              placeholder="Insira a descrição"
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ marginBottom: 0 }} for="calendar">
              Calendario
            </Label>
            <Input
              style={{ padding: "5px 10px 5px 10px", height: 32 }}
              type="select"
              name="calendar"
              id="calendar"
              value={eventData.calendar}
              onChange={handleChange}
              placeholder="Calendario"
            >
              {calendars?.map((item) => (
                <option value={item.name}>{item.name}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label style={{ marginBottom: 0 }} for="location">
              Localização
            </Label>
            <Input
              style={{ padding: "5px 10px 5px 10px" }}
              type="text"
              name="location"
              id="location"
              value={eventData.location}
              onChange={handleChange}
              placeholder="Insira a localização"
            />
          </FormGroup>
          <Row>
            <Col xs={4}>
              <FormGroup>
                <Label style={{ marginBottom: 0 }} for="startDateTime">
                  Data e hora de início
                </Label>
                <Input
                  style={{ padding: "5px 10px 5px 10px" }}
                  type="datetime-local"
                  name="startDateTime"
                  id="startDateTime"
                  value={eventData.startDateTime}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col xs={4}>
              <FormGroup>
                <Label style={{ marginBottom: 0 }} for="endDateTime">
                  Data e hora de término
                </Label>
                <Input
                  style={{ padding: "5px 10px 5px 10px" }}
                  type="datetime-local"
                  name="endDateTime"
                  id="endDateTime"
                  value={eventData.endDateTime}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col sm={4}>
              <Label style={{ marginBottom: 0 }} for={`timezone`}>
                Timezone:
              </Label>
              <Input
                style={{ padding: "5px 10px 5px 10px", height: 32 }}
                type="select"
                name={`timezone`}
                value={eventData.timezone}
                onChange={handleChange}
              >
                <option value="America/Sao_Paulo">America/Brasilia</option>
                <option value="America/Sao_Paulo">America/Sao_Paulo</option>
                <option value="America/Santiago">America/Santiago</option>
                <option value="America/New_York">America/New_York</option>
                <option value="America/Los_Angeles">America/Los_Angeles</option>
                <option value="America/Chicago">America/Chicago</option>
                <option value="America/Denver">America/Denver</option>
                <option value="America/Toronto">America/Toronto</option>
                <option value="America/Vancouver">America/Vancouver</option>
                <option value="Europe/London">Europe/London</option>
                <option value="Europe/Paris">Europe/Paris</option>
                <option value="Europe/Berlin">Europe/Berlin</option>
                <option value="Asia/Tokyo">Asia/Tokyo</option>
                <option value="Asia/Shanghai">Asia/Shanghai</option>
                <option value="Asia/Dubai">Asia/Dubai</option>
                <option value="Australia/Sydney">Australia/Sydney</option>
                <option value="Australia/Melbourne">Australia/Melbourne</option>
                <option value="Africa/Johannesburg">Africa/Johannesburg</option>
                <option value="Asia/Kolkata">Asia/Kolkata</option>
                <option value="America/Mexico_City">America/Mexico_City</option>
              </Input>
            </Col>
          </Row>
          <FormGroup className="ml-4">
            <Label style={{ marginBottom: 0 }}>
              <Input
                style={{ padding: "5px 10px 5px 10px" }}
                type="checkbox"
                name="allDay"
                checked={eventData.allDay}
                onChange={handleChange}
              />
              Dia Todo
            </Label>
          </FormGroup>

          <FormGroup>
            {eventData.notifications.map((notification, index) => (
              <Row
                key={index}
                className="notification-item"
                style={{
                  marginBottom: 10,
                  paddingBottom: 10,
                  borderBottom: "1px solid #ccc",
                }}
              >
                <Col sm={4}>
                  <Label
                    style={{ marginBottom: 0 }}
                    for={`notificationType-${index}`}
                  >
                    Tipo de Notificação:
                  </Label>
                  <Input
                    style={{ padding: "5px 10px 5px 10px", height: 28 }}
                    type="select"
                    name={`notificationType-${index}`}
                    value={notification.type}
                    onChange={(e) =>
                      handleNotificationChange(index, "type", e.target.value)
                    }
                  >
                    <option value="">Selecione o tipo</option>
                    <option value="popup">Notificação</option>
                    <option value="email">Email</option>
                  </Input>
                </Col>
                <Col sm={4}>
                  <Label
                    style={{ marginBottom: 0 }}
                    for={`notificationTime-${index}`}
                  >
                    Tempo de aviso prévio:
                  </Label>
                  <Input
                    style={{ padding: "5px 10px 5px 10px" }}
                    type="number"
                    placeholder={"Tempo de aviso prévio"}
                    name={`notificationTime-${index}`}
                    value={notification.time}
                    onChange={(e) =>
                      handleNotificationChange(index, "time", e.target.value)
                    }
                    min={1}
                    max={60}
                  />
                </Col>
                <Col sm={4}>
                  <Label
                    style={{ marginBottom: 0 }}
                    for={`notificationType-${index}`}
                  >
                    Período:
                  </Label>
                  <Input
                    style={{ padding: "5px 10px 5px 10px", height: 28 }}
                    type="select"
                    name={`notificationType-${index}`}
                    value={notification.typeUnit}
                    onChange={(e) =>
                      handleNotificationChange(
                        index,
                        "typeUnit",
                        e.target.value
                      )
                    }
                  >
                    <option value="">Selecione o tipo</option>
                    <option value="minutes">Minutos</option>
                    <option value="hours">Horas</option>
                    <option value="days">Dias</option>
                  </Input>
                </Col>
              </Row>
            ))}
            <Button color="primary" onClick={handleAddNotification}>
              Adicionar Notificação
            </Button>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter style={{ padding: "0 1rem" }}>
        <Button
          type="submit"
          onClick={(e) => handleSaveEvent()}
          color="primary"
        >
          Cadastrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
    menu: state.screening.screening.menu,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  createMenu,
  createMenuMult,
})(CadastrarEvento);
